import { fetchHPOTerms } from 'src/api/filters/hpo'

// Samples keep HPO terms as { id, name, term }, where `term` is the object the
// HPO autocomplete (HPOFilterWrapper) works with, so a round trip through it is
// stable.

export const termOf = (item) =>
  item.term || { value: item.id, label: `${item.name} (${item.id})`, name: item.name, hpo_id: item.id, synonyms: [] }

export const itemOfTerm = (term) => ({ id: term.hpo_id || term.value, name: term.name || term.label || '', term })

export const toTerms = (hpo = []) => hpo.map(termOf)

export const fromTerms = (terms = []) => terms.map(itemOfTerm).filter((i) => i.id)

export const mergeHpo = (current = [], extra = []) => {
  const seen = new Set(current.map((i) => i.id))
  return [...current, ...extra.filter((i) => i.id && !seen.has(i.id) && seen.add(i.id))]
}

/**
 * Resolves HPO IDs to terms through the HPO search, a few at a time.
 * @returns {Promise<Map<string, { id, name, term }>>}
 */
export const resolveHpoIds = async (ids) => {
  const unique = Array.from(new Set(ids))
  const out = new Map()
  const queue = [...unique]
  const worker = async () => {
    while (queue.length) {
      const id = queue.shift()
      try {
        // eslint-disable-next-line no-await-in-loop
        const results = await fetchHPOTerms({ search: id, limit: 5 })
        const match = (results || []).find((t) => t.hpo_id === id)
        if (match) {
          out.set(
            id,
            itemOfTerm({
              value: match.hpo_id,
              label: `${match.name} (${match.hpo_id})`,
              name: match.name,
              hpo_id: match.hpo_id,
              synonyms: match.synonyms || [],
            }),
          )
        }
      } catch (e) {
        // Unresolved IDs are reported by the caller.
      }
    }
  }
  await Promise.all([worker(), worker(), worker()])
  return out
}
